import { format } from "date-fns";
import { DATE_LOCALES, useI18n } from "@/lib/i18n";
import { money } from "@/lib/booking";
import { scrollToId } from "@/components/site/SmoothScroll";

export const MobileBar = ({ b, onRequest }) => {
  const { t, lang } = useI18n();
  const f = (d) => format(d, "d MMM", { locale: DATE_LOCALES[lang] });
  return (
    <div data-testid="mobile-booking-bar" className="fixed inset-x-0 bottom-0 z-40 flex items-center justify-between gap-3 border-t border-ink/10 bg-paper/95 px-5 py-3 backdrop-blur-md lg:hidden">
      <div>
        <p className="text-sm"><span className="font-semibold">{b.nights ? money(b.total) : money(b.price)}</span> <span className="text-muted2">{b.nights ? t("w.total") : `/ ${t("w.night")}`}</span></p>
        <p className="text-xs text-muted2 underline underline-offset-2">{b.range.from && b.range.to ? `${f(b.range.from)} – ${f(b.range.to)}` : t("m.pick")}</p>
      </div>
      <button
        data-testid="mobile-book-button"
        onClick={() => (b.ready ? onRequest() : scrollToId("dates"))}
        className="rounded-xl bg-cta px-6 py-3 text-sm font-semibold text-paper"
      >
        {b.ready ? t("m.book") : t("w.check")}
      </button>
    </div>
  );
};
